import type {VehicleAutosoftPlatformAdvertisingAttribute} from './VehicleAutosoftPlatformAdvertisingAttribute';

export type VehicleAutosoftPlatformAdvertisingSettings = {
  platformCode: VehicleAutosoftPlatformAdvertisingSettings.platformCode;
  enabled: boolean;
  attributes: Array<VehicleAutosoftPlatformAdvertisingAttribute>;
  hasOverrides: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
};

export namespace VehicleAutosoftPlatformAdvertisingSettings {
  export enum platformCode {
    AUTOSOFT = 'autosoft',
  }
}
